import { PropsWithChildren } from "react";
import styled from "styled-components";

interface IconProps {
  color?: string;
  size?: string;
  width?: string;
  height?: string;
  viewBox?: string;
  isClicked?: boolean;
}

export const StyledSvg = styled("svg")<IconProps>`
  width: ${({ width }) => (width ? width : "1em")};
  height: ${({ height }) => (height ? height : "1em")};
  flex-shrink: 0;
  line-height: 1em;
  fill: currentColor;
  color: ${({ color }) => color};
`;

const Icon = ({
  color = "inherit",
  viewBox = "0 0 32 32",
  width,
  height,
  size,
  isClicked,
  ...rest
}: PropsWithChildren<IconProps>): JSX.Element => {
  return (
    <StyledSvg
      viewBox={viewBox}
      {...rest}
      color={color}
      width={size ? size : width}
      height={size ? size : height}
      isClicked={isClicked}
    />
  );
};

const WineGlassIcon = (props: IconProps) => (
  <Icon {...props} viewBox="0 0 232.14 553.7">
    <path d="M203.14,534.29h-66.77c-5.36,0-9.7-4.36-9.7-9.72,0-3.26,0-6.14,0-9.01,0-53.4,.93-106.82-.41-160.18-.63-25.23,8.3-44.56,26.2-60.77,14.05-12.73,28.74-24.74,42.64-37.63,24.66-22.87,36.79-50.96,37.04-85.05,.42-57.62-18.28-110.73-36.59-163.98-1.21-3.53-7.81-7.36-11.95-7.41C139.19,.01,94.77,.46,50.36,0c-8.73-.09-12.43,3.2-14.61,11.04C25.61,47.48,13.34,83.44,5.2,120.31c-13.92,63.03-1.32,117.91,55.37,156.89,9.36,6.44,17.37,14.99,25.45,23.11,13.97,14.03,20.81,30.54,20.51,51.05-.81,55.38-.26,110.78-.31,166.17,0,2.26-.11,4.52-.25,6.94-.31,5.12-4.56,9.11-9.69,9.11H30.93c-5.36,0-9.7,4.34-9.7,9.7v.71c0,5.36,4.34,9.7,9.7,9.7H203.14c5.36,0,9.7-4.34,9.7-9.7s-4.34-9.7-9.7-9.7ZM20.29,136.75c-2.45,0-4.08-2.29-3.63-4.7C24.84,88.11,34.19,53.8,46.95,14.35c.53-1.64,1.95-2.84,3.68-2.85,22.9,0,45-.07,66.73-.04,21.73-.03,43.83,.03,66.73,.04,1.72,0,3.15,1.2,3.68,2.85,12.48,39.22,22.87,72.41,30.29,117.7,.4,2.42-1.18,4.7-3.63,4.7H20.29Z" />
  </Icon>
);

export default WineGlassIcon;
